import React from 'react';
import { Button } from '@/components/ui/button';
import { RefreshCcw, AlertTriangle } from 'lucide-react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Uncaught error:", error, errorInfo);
    this.setState({ errorInfo });
  }

  handleReset = () => {
    // Clear potentially corrupted local storage if necessary, or just reload
    // localStorage.clear(); // Use with caution
    window.location.href = '/dashboard';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
          <div className="max-w-md w-full bg-white p-8 rounded-lg shadow-lg text-center space-y-6 border border-red-100">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto">
              <AlertTriangle className="w-8 h-8 text-red-600" />
            </div>
            
            <div className="space-y-2">
              <h1 className="text-2xl font-bold text-slate-900">Something went wrong</h1>
              <p className="text-slate-500">
                The application encountered an unexpected error.
              </p>
            </div>

            <div className="bg-slate-100 p-4 rounded text-left overflow-auto max-h-40 text-xs font-mono text-slate-700">
              {this.state.error && this.state.error.toString()}
            </div>

            <div className="flex gap-4 justify-center">
              <Button onClick={() => window.location.reload()} variant="outline">
                Reload Page
              </Button>
              <Button onClick={() => { localStorage.clear(); window.location.href = '/login'; }} className="bg-red-600 hover:bg-red-700 text-white">
                <RefreshCcw className="w-4 h-4 mr-2" /> Reset App Data
              </Button>
            </div>
            
            <p className="text-xs text-slate-400 mt-4">
              If this persists, try the "Reset App Data" button to clear local storage cache.
            </p>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;